import React from 'react';

import Loading from '@decisiv/ui-components/lib/components/Loading';
import { P } from '@decisiv/ui-components/lib/components/Typography';

import { CREATING_PANEL } from './copy';
import { CreatingRow } from './styles';

/**
 * Shown while the create request is in flight.
 *
 * A single left-aligned row, unlike the success and error panels which are
 * centred — that is how the mockup draws it (Figma 787:76636).
 */
function CreatingPanel() {
  return (
    <CreatingRow>
      <Loading size="small" />
      <div>
        <P weight="semibold" style={{ margin: 0 }}>
          {CREATING_PANEL.title}
        </P>
        <P shade={1} size="small" style={{ margin: 0 }}>
          {CREATING_PANEL.body}
        </P>
      </div>
    </CreatingRow>
  );
}

export default CreatingPanel;
